<template>
  <ColumnEditModal :value="value" :configName="configName" :columnId="columnId" :editMode="editMode" @input="$emit('input', $event)" v-bind="$attrs">
    <template v-slot:edit-modal-additions="props">
      <v-layout pa-4 wrap>
        <v-input :messages="autoAssignCheckboxMessages">
          Automaticaly assign new site data source to a Monitoring Feature
          <template v-slot:prepend>
            <v-checkbox :input-value="getAutoAssignMonitoringFeatureValue(props.columnConfiguration)" :disabled="!props.editMode || !props.implemented" @click.prevent.stop="callSetColumnMetadata(autoAssignMetadataKey, !(getAutoAssignMonitoringFeatureValue(props.columnConfiguration)))">
            </v-checkbox>
          </template>
        </v-input>
        <h3> Create new Stations with the given Site Id during Import </h3>
        <v-radio-group column :value="getShouldCreateNewStationValue(props.columnConfiguration)" @change="callSetColumnMetadata(shouldCreateNewStationKey, !(getShouldCreateNewStationValue(props.columnConfiguration)))">
          <v-radio class="radio-opts" label="Allow Stations to be created in Envirodata when a new Station does not exist during an import" :value="true" />
          <v-radio class="radio-opts" label="Do not allow Stations to be created and mark the import as unsuccessful when a new Station does not exist during an import" :value="false" />
        </v-radio-group>
        <h3> Delete empty Stations during rollback </h3>
        <v-radio-group column :value="getShouldDeleteDuringRollbackValue(props.columnConfiguration)" @change="callSetColumnMetadata(shouldDeleteDuringRollbackKey, !(getShouldDeleteDuringRollbackValue(props.columnConfiguration)))">
          <v-radio class="radio-opts" label="Delete Stations that have no data associated with them during a rollback" :value="true" />
          <v-radio class="radio-opts" label="Do not delete Stations and mark the rollback as unsuccessful when attempting to delete a Station" :value="false" />
        </v-radio-group>
      </v-layout>
    </template>
  </ColumnEditModal>
</template>
<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const eddConfiguration = createNamespacedHelpers('plugin/eddConfiguration')

  import metadataFieldNames from '../../store/metadataFieldNames'
  import ColumnEditModal from './ColumnEditModal'
  export default {
    components: {
      ColumnEditModal,
    },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      configName: {
        type: String,
        required: true,
      },
      columnId: {
        type: String,
        required: true,
      },
      editMode: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        autoAssignCheckboxMessages: [
          'The site will linked to a monitoring feature with the same name. If a monitoring feature with the site name does not exist, a new one will be created.',
        ],
        autoAssignMetadataKey: metadataFieldNames.siteId_autoAssignMonitoringFeature,
        shouldCreateNewStationKey: metadataFieldNames.siteId_shouldCreateNew,
        shouldDeleteDuringRollbackKey: metadataFieldNames.siteId_shouldDeleteDuringRollback,
      }
    },
    computed: {},
    methods: {
      ...eddConfiguration.mapActions(['setColumnMetadata']),
      callSetColumnMetadata(metadataFieldName, metadataValue) {
        console.log('calling')
        this.setColumnMetadata({
          configName: this.configName,
          columnId: this.columnId,
          metadataKey: metadataFieldName,
          metadataValue: metadataValue,
        })
      },
      getAutoAssignMonitoringFeatureValue(columnConfiguration) {
        return (columnConfiguration && columnConfiguration.Metadata && columnConfiguration.Metadata[this
          .autoAssignMetadataKey]) || false
      },
      getShouldCreateNewStationValue(columnConfiguration) {
        return (columnConfiguration && columnConfiguration.Metadata && columnConfiguration.Metadata[this
          .shouldCreateNewStationKey]) || false
      },
      getShouldDeleteDuringRollbackValue(columnConfiguration) {
        return (columnConfiguration && columnConfiguration.Metadata && columnConfiguration.Metadata[this
          .shouldDeleteDuringRollbackKey]) || false
      },
    },
  }
</script>